import { Signal, untracked } from '@angular/core';
import { CustomFieldDto, SchemaFieldTargetDto, SchemaTargetDto } from 'src/app/services/api.services';
import { DataAggregation, DataModel, DataRelationshipMapping } from '../dataModel';
import { VisualContext } from './VisualContext';
import { VisualCustomField } from './VisualCustomField';
import { VisualFieldTarget, VisualInvalidTarget } from './VisualFieldTarget';
import { AppCurrencies } from 'src/app/state/app/app.reducer';
import { VisualInteractions } from './VisualInteractions';

export class VisualFieldTargetResolver {
  public readonly customFields: () => ReadonlyArray<VisualCustomField>;

  constructor(
    public readonly dataModel: DataModel,
    customFields: ReadonlyArray<VisualCustomField> | (() => ReadonlyArray<VisualCustomField>)
  ) {
    if (Array.isArray(customFields)) {
      this.customFields = () => customFields;
    }
    else {
      this.customFields = customFields as any;
    }
  }
  
  readonly find = ((t: SchemaFieldTargetDto): VisualFieldTarget => {
    let groupName = t.group?.toLowerCase();
    let fieldName = t.field?.toLowerCase();

    let target: VisualFieldTarget;

    if (groupName == VisualCustomField.GROUP_NAME.toLowerCase()) {
      let customField = untracked(() => this.customFields()).find(cf => cf.name()?.toLowerCase() == fieldName);
      if (customField) 
        target = customField.target();
    }
    else {
      target = VisualFieldTarget.fromSchemaFieldTarget(t, this.dataModel);
    }

    if (!target) 
      target = new VisualInvalidTarget(t);

    if (t.childField && !target.isChild)
      target = target.withChildField(VisualFieldTarget.mapChildName(t.childField));

    if (t.aggregation && target.canAssignAggregation)
      target = target.withAggregation(DataAggregation.from(t.aggregation));

    return target;
  });
}

export namespace VisualFieldTargetResolver {
  export type CreateOptions = {
    readonly currencies: AppCurrencies | Signal<AppCurrencies>;
    readonly dataModel: DataModel;
    readonly customFields?: ReadonlyArray<CustomFieldDto>;
    readonly schema?: SchemaTargetDto;
  };

  export function create(options: CreateOptions): VisualFieldTargetResolver {
    let { dataModel, customFields, schema } = options;

    return new VisualFieldTargetResolver(
      dataModel,
      customFields?.map(x => new VisualCustomField({
        context: VisualContext.defaultWith({
          currencies: options.currencies,
          dataModel,
          schema: dataModel.schemas.findByTarget(schema),
          interactions: null,
        }),
        dto: x,
      })) ?? []);
  }
}
